<div class="scroll-content product-sort-content">
  <div id="content-list" class="list list-md">
    @for (sortOption of profileService.productSortOptions; track sortOption) {
      <button class="item item-block item-md" text-wrap=""
        (click)="profileService.updateProductSortSelection(sortOption)">
        <div class="item-inner">
          <div class="input-wrapper width-100">
            <div class="list-label label label-md width-100 padding-left-5 padding-right-5">
              <div class="ellipses-label">{{profileService.getProductSortTranslation(sortOption.id)}}</div>
            </div>
            <div class="arrow-container">
              <div class="arrow-wrapper radio-wrapper">
                <input type="radio" value="{{sortOption.id}}"
                  [checked]="profileService.getSelectedProductSortType() !== null && profileService.getSelectedProductSortType()?.id === sortOption.id"
                  class="radio" />
              </div>
            </div>
          </div>
          <div class="button-effect"></div>
        </div>
      </button>
    }
  </div>
</div>
